import React from 'react';
import { DashboardDlys } from './DashboardDlys';
import { DashboardFloripa } from './DashboardFloripa';
import { DashboardCartocor } from './DashboardCartocor';
import { useState, useEffect } from "react";
import { SnackbarMessenger } from "src/general_components/SnackbarMessenger";
import { DashboardDlysMovimientos } from './DashboarDlysMovimientos';
import esArray from "src/general_components/functionEsArray";

export const Dashboard = () => {
    let dashboardComponent;
    let parametros_proyecto = JSON.parse(localStorage.getItem("parametros_proyecto"));
    let user_data = JSON.parse(localStorage.getItem("siam-user-data"));
    console.log("user_data", user_data);

    // eslint-disable-next-line no-unused-vars
    const [encriptacion, setEncriptacion] = useState(localStorage.getItem("encriptacion"));

    const [message, setMessage] = useState("");
    const [severity, setSeverity] = useState("success");
    const [snackbarVisible, setSnackbarVisible] = useState(false);

    const user_cuentas_parametros = JSON.parse(
        localStorage.getItem("siam-user-cuentas-parametros")
    );
    let userCuentasParametrosStorage = esArray(user_cuentas_parametros);
    const parametro_consulta_movimientos = userCuentasParametrosStorage.find(item => item.alias === "CONSULTA_MOVIMIENTOS");
    const valor_consulta_movimientos = parametro_consulta_movimientos ? parametro_consulta_movimientos.valor : null;




    if (parametros_proyecto?.id === "27") {
        if (user_data && user_data.id_perfiles === '9' && valor_consulta_movimientos === 'SI') {
            // if (user_data && user_data.id_perfiles === '9' && valor_consulta_movimientos === 'SI') {
            dashboardComponent = <DashboardDlysMovimientos />;
        } else {
            dashboardComponent = <DashboardDlys />;
        }

    } else if (parametros_proyecto?.id === "30") {
        dashboardComponent = <DashboardFloripa />;
    } else if (parametros_proyecto?.id === "24") {
        dashboardComponent = <DashboardCartocor />;
    }
    ///Habilita o no el enciptado de datos
    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === ' ') {
                setEncriptacion((prevEncriptacion) => {
                    if (prevEncriptacion === 'true') {
                        localStorage.setItem("encriptacion", 'false');
                        setSeverity('warning');
                        setMessage('Encriptado Deshabilitado');
                        setSnackbarVisible(true);
                        return 'false';
                    } else {
                        localStorage.setItem("encriptacion", 'true');
                        setSeverity('success');
                        setMessage('Encriptado Habilitado');
                        setSnackbarVisible(true);
                        return 'true';
                    }
                });
            }

            if (event.shiftKey && event.key === 'C') {
                const prev = localStorage.getItem("cognitoUse") === "true";
                localStorage.setItem("cognitoUse", String(!prev));
                setSeverity(!prev ? 'success' : 'warning');
                setMessage(!prev ? 'Uso de Cognito Habilitado' : 'Uso de Cognito Deshabilitado');
                setSnackbarVisible(true);
            }
        };

        document.addEventListener('keydown', handleKeyPress);
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <main className="c-main">
                {dashboardComponent}
            </main>
            <SnackbarMessenger
                open={snackbarVisible}
                message={message}
                severity={severity}
                close={() => {
                    setSnackbarVisible(false);
                }}
            />
        </>

    );
}

